import { Component, inject, signal } from '@angular/core';
import { LanguageConfigService } from './language-config.service';
import { LoggingService } from '../../core/utils/logging.service';
import { FormsModule } from '@angular/forms';
import { concatMap, Subject, takeUntil, tap } from 'rxjs';
import { IPreferences } from '../../core/services/dexie-indexed-db.service';
import { Select } from 'primeng/select';

interface ILanguageOption {
  img_path: string;
  label: string;
  value: string;
}

@Component({
  selector: 'app-language-config',
  imports: [FormsModule, Select],
  templateUrl: './language-config.component.html',
  styleUrl: './language-config.component.scss',
})
export class LanguageConfigComponent {
  // Injectable Service
  private langService = inject(LanguageConfigService);
  private readonly loggingService = inject(LoggingService);

  private destroy$ = new Subject<void>();

  langSelected = signal<string>('th');

  languageOptions: any[] = [
    {
      img_path: 'assets/icons/icon-en-lang.png',
      label: 'EN',
      value: 'en',
    },
    {
      img_path: 'assets/icons/icon-th-lang.png',
      label: 'ไทย',
      value: 'th',
    },
  ];
  languageOptionsDropdown: ILanguageOption[] = this.languageOptions;
  selectedLanguage = signal<ILanguageOption>(this.languageOptionsDropdown[1]);

  constructor() {
    const langState = this.langService.getLangState();
    if (langState) {
      this.langSelected.set(langState);
      this.langService.switchLanguage(langState);
    }

    this.loggingService.log('languageOptionsDropdown', this.languageOptionsDropdown);

    this.checkLanguageDexieIDB();
  }

  onSelectLang(lang: string) {
    this.loggingService.warn('Func | onSelectLang', lang);
    this.langSelected.set(lang);
    this.langService.switchLanguage(lang);
  }

  checkLanguageDexieIDB() {
    this.langService
      .getLangStateIdb()
      .pipe(
        takeUntil(this.destroy$),
        tap((res: IPreferences | undefined) => {
          // this.loggingService.warn('APP | Dexie Language State 📝📝📝', res);
          if (res) {
            const find = this.languageOptionsDropdown.find((item: ILanguageOption) => item.value === res.language);
            if (find) {
              this.selectedLanguage.set(find);
            }
          }
        }),
        concatMap((res: IPreferences | undefined) => {
          return this.langService.switchLanguageIdb(res?.language || 'th');
        })
      )
      .subscribe();
  }

  onChangeLangDropdown(event: any) {
    const langOption: ILanguageOption = event.value;
    this.loggingService.warn('Func | onChangeLangDropdown :langOption:', langOption);
    this.selectedLanguage.set(langOption);
    this.langService.switchLanguageIdb(langOption.value).pipe(takeUntil(this.destroy$)).subscribe();
  }

  onDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
